<template>
    <NewsletterSubscriber v-slot="subscriber">
        <form id="footer-newsletter" :class="{busy: subscriber.busy}">
            <TextField
                    id="newsletter-footer-email"
                    placeholder="Digite seu email"
                    autocomplete="email"
                    type="email" v-model="subscriber.fields.email"
                    inputClasses="input-lg"/>
            <LoadingButton
                    class="btn btn-lg flex-child-fixed"
                    @click="subscriber.subscribe"
                    :loading="subscriber.busy">
                Assinar
            </LoadingButton>
        </form>
    </NewsletterSubscriber>
</template>

<script>
    import LoadingButton from "../common/LoadingButton";
    import NewsletterSubscriber from "../newsletter/NewsletterSubscriber";
    import TextField from "@bit/chicorei.chicomponents.input.text-field"

    export default {
        el: '#footer-newsletter-vue',
        name: "FooterNewsletter",
        components: {TextField, LoadingButton, NewsletterSubscriber},
    }
</script>